import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";
import { cn } from "../lib/utils";

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    // Radix renders every part as a span and marks a disabled slider with
    // `data-disabled`, so a `disabled:` variant never matches. Dimming the root
    // dims the track, the range and the thumb together.
    className={cn("relative flex w-full touch-none select-none items-center data-[disabled]:opacity-50", className)}
    {...props}
  >
    <SliderPrimitive.Track
      data-slot="slider-track"
      className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-muted"
    >
      <SliderPrimitive.Range
        data-slot="slider-range"
        className="absolute h-full bg-primary"
      />
    </SliderPrimitive.Track>
    {/* The accessible name goes on the thumb, the role="slider" element; on the
        root it named a plain span. Spread only when set, so an explicit undefined
        never masks the Minimum/Maximum names Radix gives a two-thumb range. */}
    <SliderPrimitive.Thumb
      {...(ariaLabel ? { "aria-label": ariaLabel } : {})}
      {...(ariaLabelledBy ? { "aria-labelledby": ariaLabelledBy } : {})}
      className="block size-4 rounded-full border border-primary/50 bg-card shadow-soft transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40"
    />
  </SliderPrimitive.Root>
));
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
